import { measuredUsingConfigFor as wrap } from 'Components/Worksheets/Core/Helpers/configHelpers';

const getMeasuredUsingConfig = (prefix: string) => {
  const airDryBalance = wrap(`${prefix}.AirDrying.Balance`);
  const combustionBalance = wrap(`${prefix}.Combustion.Balance`);

  return {
    [`${prefix}.Combustion.TareAndAshMass`]: combustionBalance,
    [`${prefix}.AirDrying.TareMass`]: airDryBalance,
    [`${prefix}.AirDrying.TareAndWetMass`]: airDryBalance,
    [`${prefix}.AirDrying.DryMassReadings.TareAndDryMass`]: airDryBalance,
  };
};

export default getMeasuredUsingConfig;
